import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderFilter } from 'src/app/common/OrderFilter';
import { OrderService } from 'src/app/services/order.service';
import { faInfoCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { AuthorizeService } from 'src/app/auth/authorize.service';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { AppProfileService } from 'src/app/services/profile.service';
import { Observable, finalize, take, tap } from 'rxjs';
import { OrderGroup } from 'src/app/common/OrderGroup';
import { OrderSearchComponent } from '../order-search/order-search.component';
import { UserSettingsService } from 'src/app/services/user-settings.service';
import { OrderGroupListItemComponent } from '../order-group-list-item/order-group-list-item.component';

@Component({
    imports: [OrderSearchComponent, OrderGroupListItemComponent],
    selector: 'app-purchase-order-group-list',
    templateUrl: './purchase-order-group-list.component.html',
    styleUrls: ['./purchase-order-group-list.component.css']
})
export class PurchaseOrderGroupListComponent implements OnInit {
  orderService = inject(OrderService);
  private profileService = inject(AppProfileService);
  authService = inject(AuthorizeService);

  // #648: the purchases read is paged — accumulate pages for "Mehr laden".
  public orderGroups: OrderGroup[];
  public totalCount = 0;
  public loadingMore = false;
  private skip = 0;
  private pageSize = 50;
  private userSettingsService = inject(UserSettingsService);
  private destroyRef = inject(DestroyRef);
  public filter: OrderFilter;
  public faInfoCircle = faInfoCircle;
  public faFilePdf = faFilePdf;
  public isRetailer: boolean;
  public profile: ExtendedProfile = null;

  ngOnInit() {
    this.filter = this.orderService.getDefaultFilter();
    this.userSettingsService.listPageSize$.pipe(take(1)).subscribe((size) => {
      this.pageSize = size;
      this.getProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    });
  }

  private getProfile(): Observable<ExtendedProfile> {
    return this.profileService.currentProfile$.pipe(
      tap({
        next: (profile) => {
          this.profile = profile;
          this.isRetailer = profile.customer.isRetailer;
          this.search(this.filter);
        },
      })
    );
  }

  search(filter: OrderFilter) {
    if (!this.profile) return;
    this.filter = filter;
    this.skip = 0;
    this.fetchPage(false);
  }

  public loadMore() {
    if (this.loadingMore) return;
    this.loadingMore = true;
    this.skip += this.pageSize;
    this.fetchPage(true);
  }

  private fetchPage(append: boolean) {
    let states: number[] = [];
    if (this.filter) {
      this.orderService
        .getPurchaseOrderGroupsByFilter(this.filter.dateFrom, this.filter.dateTo, states, {
          skip: this.skip,
          take: this.pageSize,
        })
        .pipe(finalize(() => (this.loadingMore = false)))
        .subscribe((r) => {
          r.items.forEach((o) => (o.orderGroupDateTime = new Date(o.orderGroupDateTime)));
          this.orderGroups = append ? [...this.orderGroups, ...r.items] : r.items;
          this.totalCount = r.totalCount;
        });
    }
  }
}
